import { BASE_URL, QUERY_PARAMETER_QUERY_LABEL, QUERY_PARAMETER_VIEW_LABEL } from '../constants';

export const getDetailUrlWithoutParams = (alertId?: string, teamId?: string) => {
	const path = teamId ? `/teams/${teamId}/alerts/${alertId || ''}` : `/alerts/${alertId || ''}`;

	return `${BASE_URL}${path}`;
};

export const getDetailUrl = (alertId?: string, teamId?: string, searchedQuery?: string) => {
	const searchParams = new URLSearchParams({
		[QUERY_PARAMETER_VIEW_LABEL]: 'detail',
		[QUERY_PARAMETER_QUERY_LABEL]: searchedQuery ?? '',
	});

	const path = teamId ? `/teams/${teamId}/alerts/${alertId || ''}` : `/alerts/${alertId || ''}`;

	return `${BASE_URL}${path}?${searchParams.toString()}`;
};

export const getListUrl = (teamId?: string, searchedQuery?: string) => {
	const searchParams = new URLSearchParams({
		[QUERY_PARAMETER_VIEW_LABEL]: 'list',
		[QUERY_PARAMETER_QUERY_LABEL]: searchedQuery ?? '',
	});

	const path = teamId ? `/teams/${teamId}/alerts` : `/alerts`;

	return `${BASE_URL}${path}?${searchParams.toString()}`;
};

export const getAIViewUrl = (teamId?: string, searchedQuery?: string) => {
	const searchParams = new URLSearchParams({
		[QUERY_PARAMETER_VIEW_LABEL]: 'ai',
		[QUERY_PARAMETER_QUERY_LABEL]: searchedQuery ?? '',
	});

	const path = teamId ? `/teams/${teamId}/alerts` : `/alerts`;

	return `${BASE_URL}${path}?${searchParams.toString()}`;
};
